import { render, staticRenderFns } from "./CustomizeMetalAO.vue?vue&type=template&id=48278a29&scoped=true"
import script from "./CustomizeMetalAO.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalAO.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalAO.vue?vue&type=style&index=0&id=48278a29&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48278a29",
  null
  
)

export default component.exports